import React from "react";
import firebase from "firebase";
import { Input } from "reactstrap";

import ModalConfirm from "../hoc/ModalConfirm";
import ModalAttention from "../hoc/ModalAttention";

export default class RedefinePass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ModalTitle: <p style={{ color: "black" }}>Atenção</p>,
      modal: false,
      ModalError: false,
      ModalLeng: false,
      senha1Ok: false,
      senha2Ok: false,
      modalAjax: false,
    };
  }

  handleRedefine = async () => {
    if (this.state.senha1Ok === true && this.state.senha2Ok === true) {
      const user = firebase.auth().currentUser;
      const newPasswd = this.passwdNew.value;
      const credential = firebase.auth.EmailAuthProvider.credential(user.email, this.passwd.value);
      await user
        .reauthenticateWithCredential(credential)
        .then(() => {
          user
            .updatePassword(newPasswd)
            .then(() => {
              this.props.handleShowForm("dispositivos");
            })
            .catch((err) => {
              this.setState({ ModalLeng: true });
            });
        })
        .catch((error) => {
          this.setState({ ModalError: true });
        });
    } else {
      this.setState({ modalAjax: true });
    }
  };

  validarPass = (e) => {
    const validPass = /^\w{6,50}$/;
    const value = e.target.value;
    const campo = e.target.id;

    switch (campo) {
      case "newPasswd":
        this.setState({ senha1Ok: validPass.test(value) });
        break;
      case "newPasswd2":
        const comparar = this.passwdNew.value;
        if (value === comparar && validPass.test(comparar)) {
          this.setState({ senha2Ok: true });
        } else {
          this.setState({ senha2Ok: false });
        }
        break;
      default:
        break;
    }
  };

  onModal = () => {
    this.setState({ modal: !this.state.modal });
  };
  onModalAjax = () => {
    this.setState({ modalAjax: !this.state.modalAjax });
  };

  render() {
    return (
      <div className="col-md-6">
        {/* <a href='javascript:;' className='btn-voltar' onClick={() => this.props.handleShowForm('dispositivos')}>
          <i className='mdi mdi-keyboard-arrow-left'></i>
          Voltar
      </a> */}
        <h2>Redefinir Senha</h2>
        {this.state.ModalError ? <p style={{ color: "red" }}>INFORME A SENHA CORRETA</p> : null}
        <div className="form-group">
          <label htmlFor="inputAddress">Senha Atual*</label>
          <Input
            type="password"
            className="form-control"
            id="passwd"
            placeholder="Senha"
            innerRef={(ref) => (this.passwd = ref)}
          />
        </div>
        <div className="form-group ">
          <label htmlFor="inputpassw">Nova Senha*</label>
          <Input
            invalid={!this.state.senha1Ok}
            type="password"
            className="form-control"
            placeholder=" Nova Senha"
            id="newPasswd"
            innerRef={(ref) => (this.passwdNew = ref)}
            onChange={this.validarPass}
          />
        </div>
        <div className="form-group ">
          <label htmlFor="inputContato1">Confirme a Nova Senha*</label>
          <Input
            invalid={!this.state.senha2Ok}
            type="password"
            className="form-control"
            id="newPasswd2"
            placeholder=" Nova Senha"
            innerRef={(ref) => (this.passwdNew2 = ref)}
            onChange={this.validarPass}
          />
        </div>
        {this.state.ModalLeng ? (
          <p style={{ color: "red" }}>
            A SENHA DEVE POSSUIR MAIS DE 6 DIGITOS.
            <br /> É aconselhado ter números,letras e caracteres especiais(@..).
          </p>
        ) : null}
        <button className="btn btn-primary btn-sm mr-2" onClick={this.onModal}>
          Redefinir
        </button>
        &nbsp;
        <button
          className="btn btn-danger btn-sm"
          onClick={() => this.props.handleShowForm("dispositivos")}
        >
          Cancelar
        </button>
        <br />
        &nbsp;
        <ModalConfirm
          title={this.state.ModalTitle}
          show={this.state.modal}
          toggle={this.onModal}
          ok={this.handleRedefine}
          style={{ color: "black" }}
        >
          <p style={{ color: "black" }}>Tem certeza que deseja Alterar Seus Dados?</p>
        </ModalConfirm>
        {/* <ModalConfirm title={this.state.ModalTitle} show={this.state.modalAjax}
          toggle={this.onModalAjax} ok={this.onModalAjax} style={{ color: 'black' }}>
        
        </ModalConfirm> */}
        <ModalAttention
          title={this.state.ModalTitle}
          show={this.state.modalAjax}
          toggle={this.onModalAjax}
          ok={this.onModalAjax}
          style={{ color: "black" }}
        >
          <p style={{ color: "black" }}>A nova senha é diferente da confirmação</p>
        </ModalAttention>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Redefines/RedefinePass.js